import { render, staticRenderFns } from "./packages.vue?vue&type=template&id=e8ef8c0a&"
import script from "./packages.vue?vue&type=script&lang=js&"
export * from "./packages.vue?vue&type=script&lang=js&"
import style0 from "./packages.vue?vue&type=style&index=0&id=e8ef8c0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports